export let deMessages={
  "privacy_policy_and_terms_of_use":"Privacy Policy and Terms of Use ",
  "privacy_confirm_text":"We've updated our <a href='https://www.medtrum.com/privacy_pilicy.html' target='_blank'>Privacy Policy</a> and <a href='https://www.medtrum.com/terms_of_use.html' target='_blank'>Terms of Use</a>. To continue using EasyView, you need to read and agree to all the terms.",
  "privacy_confirm_disagree":"Disagree",
  "privacy_confirm_accept":"Accept",

  "title":"EasyView Personal",
  "title1":"EasyView Pro",
  "user":"E-Mail",
  "password":"Passwort",
  "remember":"Mich speichern",
  "forget":"Passwort vergessen?",
  "sign in":"Einloggen",
  "login":"Login",
  "sign up now":"Jetzt anmelden",
  "apply":"Jetzt beantragen",
  "contact us":"Uns kontaktieren",
  "Privacy Policy":"Datenschutzrichtlinien",
  "Terms of Use":"Nutzungsbedigungen",
  "copyright":"Copyright © 2021 Medtrum Technologies Inc. Alle Rechte vorbehalten.",

  "chooseLang":"Wählen Sie Ihr Land oder Ihre Sprache",
  "asia":"Asien",
  "europe":"Europa",

  "applyHcp":"Ein HCP-Konto beantragen",
  "sign up":"Anmelden",
  "Patient":"Patient",
  "Caregiver":"Pfleger",
  "Email":"E-Mail",
  "Mobile":"Mobilnummer",
  "Enter email":"E-Mail-Adresse eingeben",
  "Enter mobile":"Mobilnummer eingeben",
  "Verification":"Bestätigungscode",
  "Invitation":"Invitation code",
  "full name":"Geben Sie Ihren vollständigen Namen ein",
  "Enter pass":"Passwort eingeben",
  "org":"Organisation",
  "Register":"Anmelden",
  "send":"Senden",
  "agree":"Ich habe die  ",
  "privacy":" Medtrum Datenschutzrichtlinien  ",
  "and" :"und die ",
  "use":"allgemeinen Nutzungsbedingungen gelesen und akzeptiere sie.",
  "errtip1-1":"Sie müssen eine gültige E-Mail-Adresse eingeben, welche",
  "errtip1-2":" zu Ihrem Medtrum-Benutzernamen wird.",
  "errtip2":"Please enter a valid mobile number.",
  "errtip3":"Bestätigungscode ",
  "errtip4":"Incorrect invitation code.",
  "errtip5":"Benutzername ungültig.",
  "errtip6":"Your password must have 8 or more characters.",
  "errtip7":"Bitte geben Sie ihre Qrganisation ein",

  "errp1":"Das Passwort muss mindestens 3 der folgenden Zeichen enthalten: ",
  "errp2":"Großbuchstaben Kleinbuchstaben, Ziffern und Sonderzeichen.",
  "errp3":"Das Passwort muss zwischen 6 und 20 Zeichen lang sein.",
  "errp4":"Das Passwort muss sich vom Benutzernamen unterscheiden.",
  "errp5":"Passwörter mit 3 aufeinanderfolgenden Ziffern sind ungültig (z.B.: 123, 321).",
  "errp6":"Passwörter mit 3 aufeinanderfolgenden Buchstaben sind ungültig (zB: abc, cba).",
  "errp7":"Das Passwort darf keine Leerzeichen enthalten.",


  "Find account":"Passwort anfordern.",
  "Enter username":"Bitte geben Sie Ihren Benutzernamen ein.",
  "Next":"Weiter",
  "Cancel":"Abbrechen",
  "Back":"Zurück",
  "Enter veri":"Bestätigungscode",
  "Verify notice":"Der Bestätigungscode wurde Ihnen in einer E-Mail zugesendet.",
  "Create new":"Neues Passwort erstellen",
  "Create new notice":"Bitte erstellen Sie ein neues Passwort. Ihr Passwort muss mindestens 6 Zeichen lang sein.",
  "New pass" :"Neues Passwort",
  "Completed":"Abgeschlossen",
  "Created":"Neues Passwort erstellt.",
  "Login Now":"Jetzt einloggen",

  "Delete":"Löschen",
  "New Patient":"New Patient",
  "Add Patient":"Patient hinzufügen",
  "Filter":"Filter",
  "Name":"Name",
  "Gender":"Geschlecht",
  "Age":"Alter",
  "Type":"Typ",
  "Duration":"Dauer",
  "Connections":"Kontoersteller",
  "UploadTime":"Zeitpunkt des Uploads",
  "Year":"jahr",
  "Years":"jahre",
  "Month":"mois",
  "Month2":"Monat",
  "Months":"mois",
  "Invite":"Einladen",
  "Invited":"Eingeladen",
  "All":"Alle",
  "Female":"Weiblich",
  "Male":"Männlich",
  "Not Set":"Not Set",
  "Type 1":"Typ 1",
  "Type 2":"Typ 2",
  "Gestational":"Schwangerschäftsdiabetes",
  "Prediabetes":"Prädiabetes",
  "LADA":"Typ 1.5 LADA",
  "Apply":"Anwenden",
  "disUn":"Diabetes-Typ nicht angegeben",
  "ageUn":"Alter nicht angegeben",
  "genUn":"Geschlecht nicht angegeben",
  "addP":"Patienten hinzufügen",
  "newP":"Neuer Patient",
  "findP":"Patienten finden",

  "GDRNF":"Nicht spezifiziert",
  "GDRF":"Weiblich",
  "GDRM":"Männlich",
  "女":"Männlich",

  "DBTNF":"Nicht spezifiziert",
  "DBT1":"Typ 1",
  "DBT2":"Typ 2",
  "DBTLADA":"Typ 1.5 LADA",
  "DBTPRE":"Prädiabetes",
  "DBTGEST":"Schwangerschäftsdiabetes",
  "前期":"beFore",
  "beFore":"beFore",
  "MODY":"Mody",

  "No selection":"No selection",
  "unspecif":"Nicht spezifiziert",
  "register":"Patient",
  "hcp":"Kliniker/in",

  "BG":"BG",
  "CARB":"Kohlenhydrate",
  "INS":"Injektion",
  "EXR":"Übung",
  "OTR":"Other",
  "HBA1C":"HbA1c",
  "DOSE":"DOSE",
  "URINEK":"Urinketon",
  "HEL":"HEL",
  "OTR1":"Andere",
  "Loading":"Lädt",

  "home":"Zuhause",
  "pID":"Patienten-ID",
  "fullName":"Vollständiger Name",
  "gender":"Geschlecht",
  "height":"Größe",
  "weight":"Gewicht",
  "cm":"cm",
  "kg":"kg",
  "birthday":"Geburtstag",
  "disType":"Diabetes-Typ",
  "disDate":"Zeitpunkt der Diagnose",
  "Address":"Adresse",
  "Postcode":"Postleitzahl",
  "Inpatient":"Stationärer Patient",
  "Yes":"Ja",
  "No":"Nein",
  "Pno":"Patienten-Nr.",
  "Bno":"Betten-Nr.",
  "create":"Erstellen",
  "Telephone":"Festnetznummer",

  "enterU":"Benutzernamen eingeben (E-Mail)",
  "search":"Suchen",
  "noU":"Ein Benutzername ist erforderlich.",
  "searchR":"Ergebnisse durchsuchen",
  "uername":"Benutzername",
  "alias":"Alias",
  "remove":"Entfernen",
  "viewG":"Diagramme anzeigen",
  "sendR":"Anfrage senden",
  "rSent":"Ihre Anfrage wurde gesendet.",
  "cancelR":"Anrage abbrechen",

  "VcodeTip1":"Nicht erhalten? Bitte warten Sie eine Minute und ",
  "VcodeTip2":" versuchen Sie es erneut.",
  "VcodeTip3":"Wir haben gerade einen Bestätigungscode gesendet an ",
  "Entercode":"Code eingeben",
  "Getcode":"Code erhalten",

  "messages":"Nachrichten",
  "profile":"Profil",
  "sign out":"Abmelden",
  "changeP":"Passwort ändern",
  "connection":"Verbindungen",

  "myP":"Mein Profil",
  "Portrait":"Profilfoto",
  "Profession":"Beruf",
  "DPRONF":"Nicht spezifiziert",
  "DPROENDOCRIN":"Endokrinologe",
  "DPRODIABTRA":"Diabetes-Berater",
  "DPRONURSE":"Krankenpfleger",
  "DPRODIATIT":"Ernährungsberater",
  "DPROOTR":"Sonstiger HCP",
  "Organization":"Organisation",
  "Bio":"Bio",
  "save":"Speichern",
  "oldPa":"Altes Passwort",
  "newPa":"Neues Passwort",
  "RePa":"Passwort erneut eingeben",
  "forgetY":"Passwort vergessen?",
  "applyM":"Anwenden",
  "oldErr":"Das alte Passwort ist nicht korrekt",
  "EntTheSame":"Geben Sie das neue Passwort erneut",
  "EnterOld":"Geben Sie das alte Passwort ein",

  "pList":"Patientenliste",
  "connections":"Verbindungen",
  "settings":"Einstellungen",
  "monitor":"Überwachen",
  "graphs":"Berichte",
  "events":"Ereignisse",
  "records":"Protokolle",
  "qPrint":"Schnelldruck",

  "sensorIn":"Sensorinformationen",
  "timeOfLaRead":"Zeitpunkt des letzten Sensor-Messwertes",
  "tranSn":"Sendeanlage-SN",
  "status":"Status",
  "sensorLife":"Verbleibende Sensorlaufzeit ",
  "lastSenorRead":"Letzter Sensor-Messwert",
  "TranBattery":"Sender-Batterie",
  "sg":"SZ",
  "alert":"Warnmeldung",
  "target":"Ziel",
  "hypo":"Hypo",
  "sensorGlucose":"Sensor-Glukose",
  "calib":"Kalibrierung",
  "newSen":"Neuer Sensor",
  "warm":"Aufwärmen",
  "InsulinPump":"Aufwärmen",
  "timeOfLaPump":"Zeitpunkt der letzten Pumpendaten",
  "pumpSN":"Pumpenbasis-SN",
  "ReserviorLife":"Verbleibende Patch-Behälter-Lebensdauer",
  "InsulinLeft":"Verbleibendes Insulin",
  "basal":"Basal",
  "bolus":"Bolus",
  "totalBasal":"Gesamte Tagesdosis Basal",
  "lastBolus":"Letzter Bolus",
  "activeInsulin":"Aktives Insulin",
  "totalBolus":"Gesamte Tagesdosis Bolus",
  "tampBasal":"Temp-Basal",
  "normalBolus":"Normaler Bolus",
  "extendBolus":"Verzögerter Bolus",
  "manualStop":"Manuelle Unterbrechung",
  "autoStop":"Automatische Unterbrechung",
  "auto suspend":"Automatische Unterbrechung",
  "stop":"Abgabestopp",
  "newPatch":"Neuer Patch",
  "tempBasal":"Tempbasal",
  "N":"N",
  "E":"V",
  "CN1":"CN",
  "CE":"CV",

  "staticSettings":"Berichte-Einstellungen",
  "dataSource":"Datenquelle",
  "unit":"Einheit",
  "glucoseTarget":"Grenzwerte der Glukose-Zielwerte",
  "overall":"Insgesamt",
  "Hypoglycemia":"Hypoglykämie",
  "timePeriod":"Zeitraum",
  "postMeal":"Post-Mahlzeit-Analyse",
  "Breakfast":"Frühstück",
  "Lunch":"Mittagessen",
  "Dinner":"Abendessen",
  "night":"Nacht",
  "Before":"Vor",
  "After":"Nach",
  "Low":"Niedrig",
  "High":"Hoch",
  "From":"Von ",
  "To":"Bis",
  "Hours":"stunden",
  "Reset":"Standardeinstellungen wiederherstellen",
  "RealTime":"Echtzeit",
  "uploaded":"Hochgeladen",
  "sensor":"Sensor",
  "pdmSN":"PDM-SN",
  "startTime":"Startzeit",
  "endTime":"Endzeit",
  "uploadTime":"Upload-Zeit",
  "pdm":"PDM",
  "Uploaded":"Hochgeladen",
  "Patch Pump":"PDM ",
  "overLapp":"Sitzungen überlappen sich",
  "showAlert":"Warnungen zeigen",

  "dashboard":"Dashboard",
  "dboard_glucose_statistics":"Statistiken",
  "dboard_glucose":"Glucose",
  "dboard_glucose_avg":"Durchschnittlich",
  //"dboard_sd":"SD",
  //"dboard_num":"#",
  "dboard_cgm":"CGM",
  "dboard_cgm_avg":"Durchschnittlich",
  //"dboard_sd":"SD",
  //"dboard_num":"#",
  "dboard_insulin":"Insulin",
  "dboard_insulin_avg":"Durchschnittliche tägliche Dosis",
  //"dboard_sd":"SD",
  //"dboard_num":"#",
  "dboard_num_days":"# days",
  "dboard_carbs":"Kohlenhydrate",
  "dboard_carbs_avg":"Durchschnittliche Kohlenhydrate / Tag",
  //"dboard_sd":"SD",
  //"dboard_num":"#",
  "dboard_exercise":"Übung",
  "dboard_exercise_avg":"Durchschnittliche Zeit / Tag",
  "dboard_sd":"SD",
  "dboard_num":"#",
  "est_a1c_t1":"Geschätzte A1C:",
  "est_a1c_t2":" aus SG-Werten berechnet",
  "est_a1c_t3":"Hinweis: Geschätzter A1C-Wert ersetzt keine Labormessung",

  "dboard_statistics":"Statistiken",
  "dboard_BG":"BG",
  "dboard_SG":"SG",
  "dboard_BG_calibration":"BG / Kalibrierung (pro Tag)",
  "dboard_AUC_high":"AUC hoch> 11,0 mmol / l",
  "dboard_AUC_low":"AUC niedrig <5,2 mmol / l",
  "dboard_highest_value":"Höchster Wert",
  "dboard_lowest_value":"Niedrigster Wert",
  "dboard_pump":"Pumpe",
  "dboard_avg_daily_dose":"Durchschnittliche tägliche Dosis",
  "dboard_SD":"SD",
  "dboard_daily_basal":"Täglicher Basal",
  "dboard_daily_bolus":"Täglicher Bolus",
  "dboard_avg_bolus_num":"Durchschnittliche Boluszahl pro Tag",
  "dboard_avg_suspend_time":"Durchschnittliche Suspend-Zeit",
  "dboard_avg_reservoir_usage":"Durchschnittliche Reservoirnutzung",
  "dboard_days":"days",
  "dboard_manual_bolus":"Manueller Bolus (Volumen / Nr. Pro Tag)",
  "dboard_normal":"-Normal",
  "dboard_extend":"-Verzögert",
  "dboard_combo":"-Combo",
  "dboard_bolus_calculator":"Bolusrechner (Volumen / Nr. Pro Tag)",
  "dboard_food_bolus":"-Mahlzeitbolus-Rechner",
  "dboard_corr_bolus":"-Korrekturbolus-Rechner",
  "dboard_override_add":"-Überreiten (+)",
  "dboard_override_sub":"-Überreiten (-)",

  "dboard_report":"Dashboard erstellen",

  "daily":"Tägliche Zusammenfassung",
  "date":"Datum",
  "print":"Drucken",
  "carbs":"Kohlenhydrate",
  "exercise":"Bewegung",
  "heavy":"Viel",
  "Medium":"Mittlere",
  "Light":"Wenig",
  "dailyReport":"Täglicher Zusammenfassungsbericht",
  "devices":"Geräte",
  "tran":"Sendeanlage",
  "pumpBase":"Pumpenbasis",
  "HbA1c":"HbA1c",
  "statics":"Statistiken",
  "glucose":"Glukose",
  "item":"Artikel",
  "BG1":"BZ",
  "SG1":"SG",
  "avgSD":"Durchschn (mmol/L)±SD",
  "avgSD1":"Avg±SD",
  "min":"Mindest",
  "max":"Max",
  "ofRead":"# an Messungen",
  "ofHypo":"# an Hypo/Dauer(min)",
  "ofAlert":"# an Warnmeldungen",
  "insulin":"Insulin",
  "insulin2":"Insulin",
  "totalDose":"Gesamt-Tagesdosis",
  "foodBolus":"Mahlzeitbolus",
  "Food+coor":"Food+corr",
  "calibBolus":"Korrekturbolus",
  "durationStop":"Dauer der Unterbrechung (min)",
  "ofPumpAlert":"# an Pumpenalarmen",
  "ofMeal":"# an Mahlzeiten",
  "totalExerTime":"Gesamte Bewegungsdauer",
  "exerNum":"# an Bewegungsübungen",
  "avgInten":"Durschnittliche Intensität",
  "target1":"Ziel",
  "high1":"Hoch ",
  "low1":"Niedrig ",
  "BG Reading":"BZ-Messwerte",

  "dayByday":"Tägliche Übersicht",
  "dayBydayRe":"Tägliche Übersicht",
  "period":"Zeitraum",

  "sensorOverlay":"Sensor-Overlay",
  "set":"Einstellen",
  "setPeriod":"Zeitraum einstellen",
  "Weekdays":"Wochentags",
  "Weekends":"Wochenenden",
  "Mon":"Mo",
  "Tue":"Di",
  "Wed":"Mi ",
  "Thur":"Do",
  "Thu":"Do",
  "Sat":"Sa",
  "Fri":"Fr ",
  "Sun":"So",
  "Average":"Durschnittlich",
  "sensorOlRe":"Sensor-Overlay-Bericht",
  "Avg":"Avg",
  "±SD":"±SD",
  "ofhypo":"# an Hypo",
  "Everyday":"jeden Tag",

  "TrendAna":"Trendanalyse",
  "TrendRe":"Trendanalyse-Bericht",
  "sensorGlu":"Sensor-Glukosewert ",
  "ofBGtest":"# an BZ-Tests",
  "Basics":"Grundlagen",
  "static":"Statistiken",
  "Med":"Med",
  "med":"median",
  "Q1":"Q1",
  "Q3":"Q3",
  "Q11":"Q1",
  "Q31":"Q3",
  "IQR":"IQR",
  "SD":"SD",
  "CV":"CV",
  "SE1":"SE Mittelewert",
  "distri":"Verteilung",
  "stab":"Stabilität",
  "#high":"# an Hoch",
  "#low":"# an Niedrig",
  "aucBelow":"AUC unter dem unteren Grenzwert",
  "aucAbove":"AUC über dem oberen Grenzwert",
  "bgRead":"BZ-Messwerte",
  "bgRead1":"BZ-Messwerte",
  "total":"Gesamt",
  "avg_daily_basal":"Basal",
  "avg_daily_bolus":"Bolus",
  "ofBolus":"# an Bolus",
  "avgBolus":"Ø Bolus",
  "Dura1":"Dauer (min)",
  "Avg/Total":"Avg/Total",
  "high":"Hoch",
  "low":"Niedrig",
  "#hypo":"# an Hypo",
  "ofExer":"# an Bewegungsübungen",

  "logbook":"Logbuch",
  "dailyTotal":"Tagessumme",
  "High Glucose":"Hohe Glukosewerte",
  "Low Glucose":"Niedrige Glukosewerte",
  "No Active Patch":"Kein aktiver Patch",
  "Missed Meal":"Verpasste Mahlzeit",
  "Multiple BG Readings":"Mehrere BZ-Messwerte",
  "Stop Patch":"Patch-Stopp",
  "Others":"Andere",
  "Other Events":"Andere Ereignisse",
  "logRe":"Logbuch-Bericht",

  "DeviceSetting":"Geräte-Einstellungsübersicht",
  "Insulin Pump":"Insulinpumpe",
  "MaxBasalRate":"Maximale Basalrate",
  "BasalPatterns":"Basalvorlagen",
  "Selected Basal Pattern":"Ausgewählte Basalvorlage",
  "Maximum Bolus":"Maximaler Bolus",
  "Combo/Extended Bolus":"Combo/Verzögerter Bolus",
  "BG Reminder":"BZ-Erinnerung",
  "Bolus Increment":"Bolusschritt",
  "Bolus Calculator":"Bolus-Rechner",
  "Active Insulin Time":"Aktive Insulinzeit",
  "IC Ratios":"KI-Verhältnisse",
  "Insulin Sensitivity":"Insulinempfindlichkeit",
  "BG Target":"BZ-Zielwert",
  "Bolus Reminder":"Bolus-Erinnerung",
  "CGM":"CGM",
  "CGM System":"CGM-System",
  "Glucose Unit":"Glukose-Einheit",
  "Glucose Limits":"Glukose-Grenzwerte",
  "Predicitive Alerts":"Vorwarnungen",
  "Rate Alerts":"Änderungsrate-Warnungen ",
  "type":"Typ",
  "time":"Zeit",
  "data":"Daten",
  "Rate":"Rate",
  "Calibration Reminder":"Kalibrierungs-Erinnerung",
  "Calibration Repeat":"Kalibrierungs-Wiederholung",
  "Snooze":"Erinnerungsintervall",
  "Audio Options":"Ton-Optionen",
  "Confidence Reminder":"Eingabe-Erinnerung",
  "Backlight":"Hintergrundbeleuchtung",
  "Sec":"sek",
  "Alarm Clock":"Wecker",
  "Patch Expiration":"Patch-Verfall",
  "Sensor Expiration":"Sensor-Verfall",
  "Hourly Max":"Maximale Stundenabgabe",
  "Daily Max":"Maximale Tagesabgabe",
  "Low Reservoir":"Behälterstand niedrig",
  "Low Suspend":"Niedrige Unterbrechung",
  "Predictive Low Suspend":"Vorwarnung Niedrige Unterbrechung",
  "Rise":"Zunahme",
  "Fall":"Abnahme",
  "Auto Off":"Automatische Unterbrechung",
  "Standard":"Standard",
  "Exercise":"Bewegung",
  "Holiday":"Urlaub",
  "ProgramA":"Vorlage A",
  "ProgramB":"Vorlage B",
  "--":"--",
  "Insulin":"Insulin",

  "SUSA":"Automatische Unterbrechung",
  "SUSHM":"Überschreitet max. stündliche Abgabe",
  "SUSDM":"Überschreitet max. GTD",
  "SUSLSG":"Niedrige Unterbrechung",
  "SUSPLSG":"Vorwarnung Niedrige Unterbrechung",
  "Pump Restarted":"Pumpe neu gestartet",
  "Meter BG Now":"BZ jetzt messen",
  "Sensor Exp in 2 Hours":"S-Verfall in 2 Std.",
  "Sensor Exp in 6 Hours":"S-Verfall in 6 Std",
  "Sensor Exp in 30 Min":"S-Verfall in 30 Min.",
  "Sensor Calibration Error":"Sensor-Kal.-Error",
  "Sensor Error":"Keine Lesungen",

  "Device Settings Report":"Geräte-Einstellungsbericht",
  "24h Total":"24h-Gesamt",
  "Device Settings at":"Geräte-Einstellungen am",
  "Start":"Start",
  "Combo/Ext Bolus":"Combo/Verzögerter Bolus",
  "Time Format":"Zeitformat",
  "Device Options（CGM System)":"Geräte-Optionen (CGM-System)",
  "Device Options（Insulin Pump)":"Geräte-Optionen (Insulinpumpe)",
  "Dispay Settings (Screen)":"Anzeige-Einstellungen (Bildschirm)",
  "Dispay Settings (Backlight)":"Anzeige-Einstellungen (Hintergrundbeleuchtung)",
  "Graph Range":"Diagramm-Bereich",
  "Range":"Bereich",
  "Repeat":"Wiederholung",
  "Glucose Alerts":"Glukose-Warnmeldungen",
  "Alert Silence":"Warnmeldung stummschalten",

  "Create":"Erstellen",
  "Event Filter":"Ereignis-Filter",
  "HbA1c1":"HbA1c",
  "Urine Ketone":"Urinketon",
  "Injection":"Injektion",
  "Other":"Andere",
  "Event Type":"Ereignis-Typ",
  "Details":"Details",
  "Notes":"Notizen",
  "Source":"Quelle",
  "edit":"Bearbeiten",
  "Action":"Aktion",
  "EventReport":"Ereignis-Zusammenfassungsbericht",
  "By Date":"Nach Datum",
  "By Category":"Nach Kategorie",
  "Event Summary":"Ereignis-Zusammenfassung ",
  "No data":"Keine Daten",
  "No1":"Keine",
  "data1":"Daten",
  "#":"#",
  "BG Summary":"BZ-Zusammenfassung",
  "Carbs Summary":"Kohlenhydrate-Zusammenfassung",
  "Injection Summary":"Injektions-Zusammenfassung",
  "Exercise Summary":"Bewegungs-Zusammenfassung",
  "Input Notes":"Geben Sie eine Notiz ein",

  "Profile":"Profil",
  "Complications":"Komplikationen",
  "Concomitant diseases":"Begleiterkrankungen",
  "Suggestion":"Empfehlung",
  "Coronary heart disease":"koronare Herzkrankheit",
  "High blood lipids":"hohe Blutfettwerte",
  "High blood pressure":"Bluthochdruck",
  "Kidney disease":"Nierenerkrankung",
  "Neuropathy":"Neuropathie",
  "Obesity":"Adipositas",
  "Peripheral arterial disease":"periphere Arterienerkrankung",
  "Retinopathy":"Retinopathie",
  "Smoking addiction":"Rauchsucht",
  "Enter date":"Datum eingeben",
  "Enter suggestion":"Empfehlung eingeben",
  "Enter Notes":"Eine Notiz eingeben.",
  "Select":"Auswählen",
  "Prescription":"Verschreibung",
  "Medicine":"Medizin",
  "Dose":"Dosis",
  "Enter medicine":"Medizin eingeben",
  "Enter dose":"Dosis eingeben",
  "Enterdis":"Enter concomitant diseases",
  "Add note":"Notiz hinzufügen",
  "Add Content":"Die maximale Länge beträgt 1000 Zeichenstellen",
  "Other suggestions":"Andere Empfehlungen",
  "OK":"OK",
  "HCP":"HCP",
  "Content":"Inhalt",
  "Records Report":"Protokoll-Bericht",

  "Quick Print":"Schnelldruck",
  "Quick Print Settings":"Schnelldruck-Einstellungen",
  "Select duration":"Dauer auswählen:",
  "One Week":"Eine Woche",
  "One Month":"Ein Monat",
  "One Quarter":"Ein Quartal",
  "End date":"Enddatum ",
  "Yesterday":"Gestern",
  "Last Sunday":"Letzten Sonntag",
  "Last Saturday":"Letzten Samstag",
  "Last Day of Last Month":"Last Day of Last Month",
  "Last Day of Last Quarter":"Last Day of Last Quarter",
  "Customized":"Anpassen",
  "Week Filter":"Filter nach Wochen",
  "Select reports to print":"Berichte zum Drucken auswählen",
  "Daily Summary":"Tägliche Zusammenfassung",
  "Day By Day Overview":"Tägliche Übersicht",
  "Sensor Overlay":"Sensor-Overlay",
  "Trend Analysis":"Trendanalyse",
  "Logbook":"Logbuch",
  "Device Settings Review":"Geräte-Einstellungsübersicht",
  "createReport":"Bericht erstellen",

  "Segment Analysis":"Segmentanalyse",
  "Sensor Glucose Profile":" Sensor-Glukoseprofil",
  "# of Boluses":" # von Bolus",
  "Bolus Insulin":"Bolus-Insulin",
  "Basal Pattern":"Basalvorlage",
  "Segment Analysis Report":"Segmentanalysebericht",
  "Avg Glucose":"Durchschn Glucose ",
  "Below":"Unter",
  "In Target Range":" Im Zielbereich",
  "Coefficient of variation":"Variationskoeffizient",
  "% Time CGM Active":"  % der Zeit für aktives CGM",
  //"est_a1c_t1":"Geschätzter A1C-Wert:",
  //"est_a1c_t2":"aus SG-Werten berechnet",
  //"est_a1c_t3":"Hinweis: Der geschätzter A1C-Wert darf Labormessung nicht ersetzen",



  "acceptTip":" hat Ihre Anfrage zugelassen, seine/ihre Gesundheits-Informationen per Remote-Ansicht zu betrachten.",
  "cancelTip":" hat Ihre Zugriffsberechtigung auf seine/ihre Gesundheits-Informationen per Remote-Ansicht beendet. Sie können die Berechtigung erneut anfragen, falls nötig.",
  "rejectTip":" hat Ihre Anfrage auf Remote-Ansicht abgelehnt.",
  "Read":"Lesen",

  "Connection":"Verbindung",
  "connections1":"Verbindungen",
  "Add Connection":"Verbindung hinzufügen",
  "SG":"SZ",
  "Active Insulin":"Aktives Insulin",
  "Stop following":"Nicht mehr folgen",
  "Enter username (email)":"Benutzernamen eingeben (E-Mail)",
  "Search results":"Ergebnisse durchsuchen",
  "Send request":"Anfrage senden",
  "View graphs":"Diagramme ansehen",
  "Agree":"Zustimmen",
  "Deny":"Ablehnen",
  "Remove":"Entfernen",
  "Cancel Requset":"Requset abbrechen",
  "Remark":"Anmerkung",

  "Warm up":"Aufwärmen",
  "Monitoring":"Überwachung",
  "Transmitter Error":"Transmitter-Error",
  "Sensor Failure":"Sensor-Fehler ",
  "Sensor Expired":"Sensor verfallen",
  "Lost Sensor":"Sensorsignal verloren",
  "Not Calibrated":"Nicht kalibriert",
  "Calibrating":"Kalibriert",
  "Calibration Needed":"Kalibrierung erforderlich",
  "Calibration Error":"Kalibrierungs-Error",
  "Charging Battery":"Batterie läd auf",
  "Battery Charged":"Batterie aufgeladen",

  "To be filled":"Befüllen erforderlich",
  "Filled with insulin":"Mit Insulin befüllt",
  "Priming":"Vorpumpen",
  "Priming completed":"Vorpumpen abgeschlossen",
  "Inserting needle":"Nadel wird eingeführt",
  "Patch activated":"Patch aktiviert",
  "Delivering Basal":"Gibt Basal ab",
  "Exceeds Max 1 Hour Delivery":"Überschritten max. stündliche Abgabe",
  "Exceeds Max TDD":"Überschritten max. GTD",
  "Suspend":"Unterbrechen",
  "Occlusion Detected":"Verschluss entdeckt",
  "Patch Expired":"Patch verfallen",
  "Empty Reservoir":"Reservoir Leer",
  "Patch Error":"Patch-Error",
  "Pump Base Error":"Pumpenbasis-Error",
  "Patch Battery Depleted":"Patch-Batterie leer",
  "Magnetic sensor not calibrated":"Magnetsensor nicht kalibriert",

  "Patient Profile":"Patientenprofil",

  "On":"An",
  "on":"An",
  "Off":"Aus",
  "off":"Aus",

  "CORONARY_HEART_DISEASE":"koronare Herzkrankheit",
  "HIGH_BLOOD_LIPIDS":"hohe Blutfettwerte",
  "HIGH_BLOOD_PRESSURE":"Bluthochdruck",
  "KIDNEY_DISEASE":"Nierenerkrankung",
  "NEUROPATHY":"Neuropathie",
  "OBESITY":"Adipositas",
  "PERIPHERAL_ARTERIAL_DISEASE":"periphere Arterienerkrankung",
  "RETINOPATHY":"Retinopathie",
  "SMOKING_ADDICTION":"Rauchsucht",

  "saveTip":"Erfolgreich gespeichert.",
  "changePaTip":"Ihr Passwort wurde geändert.",
  "enterEmTip":"Geben Sie Ihre E-Mail-Adresse an.",
  "verErrTip":"Bestätigungscode ungültig.",

  "chooseEventTip":"Wählen Sie die zu druckenden Ereignisse aus",
  "chooseDataTip":"Wählen Sie Daten zum Drucken",
  "dateWrongTip":"Die Endzeit sollte nicht früher als die Startzeit sein",
  "infoWrongTip":"Bitte füllen Sie alle erforderlichen Felder aus.",
  "createdSuccssTip":"Erfolgreich erstellt",
  "selectData":"Wählen Sie Daten zum Speichern",

  "acceSu":"Verbindungsanfrage akzeptiert  ",
  "acceEr":"Fehler: neue Verbindung  nicht hinzugefügt",
  "rejeSu":"Verbindungsanfrage abgelehnt",
  "rejeEr":"Fehler bei Anforderung-Ablehnen",

  "userNotExist":"Der Benutzername existiert nicht.",
  "Password incorrect":"Ungültiges Passwort.",
  "UserType incorrect":"Falschner Benutzertyp",

  "registSuccess":"Ihr Konto wird erfolgreich erstellt",
  "registFailed":"Fehler: neues Konto nicht registriert",
  "sentSuccess":"Nachtricht erfolgreich gesendet",
  "sentFailed":"Nachricht-Senden fehlgeschlagen",
  "Input error":"Eingabe Fehler",

  "deletePtip":"Sind Sie sicher, dass Sie diese Patienten löschen möchten?",
  "deleteEvents":"Möchten Sie diese Ereignisse wirklich löschen?",
  "deleteData":"Real-time and uploaded data will be deleted. The deleted data can't be restored. Are you sure to delete data?",
  "deleteThis":"Sind Sie sicher, dass Sie löschen möchten ?",
  "confirm":"Bestätigen",
  "deleteSuccess":"Löschen erfolgreich",
  "deleteFailed":" Inhalt-Löschen fehlgeschlagen",
  "modifySuccess":"Änderung erfolgreich ",
  "modifyFailed":"Änderung fehlgeschlagen",
  "createSuccess":"Erfolgreich erstellt",
  "createFailed":"Erstellen fehlgeschlagen",
  "editSuccess":"Erfolgreich bearbeiten",
  "editFailed":"Bearbeiten fehlgeschlagen",
  "Time overlapped":"Die Sitzungen, die Sie ausgewählten, überlappen sich",

  "stopFollow":"Sind Sie sicher, dass Sie diesen Patienten nicht mehr folgen möchten?",
  "CancelTip1":"Sind Sie sicher,  diese Verbindung zu löschen?",

  "Warning":"Warnung",
  "agreeConnect":"Wenn Sie auf ,Akzeptieren“ klicken und die Verbindungsanfrage akzeptieren, werden Ihre Gesundheitsdaten für die neue Verbindung zugänglich.",
  "denyConnect":"Sind Sie sicher, die Verbindungsanfrage abzulehnen?",
  "deleteConnect":"Sind Sie sicher,  diese Verbindung zu löschen? Wenn Sie ihn / sie löschen, wird die Verbindung nicht in der Lage sein, Ihre Gesundheitsdaten zu sehen.",

  "Choose the events to print":"Choisissez les événements à imprimer",
  "tryAgain":"Versuchen Sie es nochmal",
  "username and password is required":"username and password is required",
  "A name is required":"Ein Name ist erforderlich.",
  "username is required":"Ein Benutzername ist erforderlich.",
  "The date choose wrong":"falsches Datum gewählt",
  "Date no more than 14 days":"Sie können nicht mehr als 14 Tage wählen",

  "CancelTip":"Sind Sie sicher,  die Verbindung zu löschen?",
  "removeConnect":"Erfolgreich gelöscht",

  "dateErr1":"Sie können nicht mehr als 90 Tagen wählen",
  "dateErr2":"Das Enddatum darf nicht vor dem Startdatum liegen.",

  "Not Filled":"Nicht spezifiziert",
  "Today":"Heute",
  "duration":"Dauer",
  "interval":"Interval",
  "7 days":"7 Tage",
  "14 days":"14 Tage",
  "30 days":"30 Tage",
  "90 days":"90 Tage",
  "g":"g",

  "Sound+Vibrate":"Audio + Vibration",
  "Sound":"Audio",
  "Vibrate":"Vibrieren",
  "Silent":"Bitte nicht stören",
  "1":"Einmal",
  "2":"Täglich",
  "noMes":"Es gibt keine Nachrichten.",
  "noConnect":"Es gibt keine Verbindungen.",
  "Customize":"Anpassen",
  "GB":"United Kingdom",
  "CN":"China",
  "FR":"France",
  "DD":"Germany",
  "DE":"Germany",
  "SE":"Sweden",
  "AU":"Australia",
  "HKF":"Hongkong",
  "HU":"Hungary",
  "IT":"Italy",
  "NL":"Netherlands",
  "Nor":"Norway",
  "PT":"Portugal",
  "ES":"Spain",
  "TR":"Turkey",

  "Jan":"Jan",
  "Feb":"Feb",
  "Mar":"Mär",
  "Apr":"Apr",
  "May":"Mai",
  "Jun":"Jun",
  "Jul":"Jul",
  "Aug":"Aug",
  "Sep":"Sep",
  "Oct":"Okt",
  "Nov":"Nov",
  "Dec":"Dez",
  "ApplyTip":" Anfrage um Ihre Daten zu sehen.",
  "noReadings":"Keine Lesungen",

  "daop_A6_system":"A6 Touchcare System",
  "daop_easytouch_easyview":"EasyTouch / EasyView iPad",
  "daop_TY012_TY015":"TY012/TY015",
  "daop_easysense":"EasySense",
  "daop_delete_data":"Delete Data",
  "daop_uploaded_data":"daten hochgeladen",
  "daop_uploaded_data_text":"Die Daten stammen von der EasyTouch App oder der EasyView iPad App.",
  "daop_realtime_data":" Echtzeitdaten",
  "daop_realtime_data_text":"The data is from EasySense App or EasyPatch App.",

  "ins_unit":"(IE)",
  "ins_unit2":"IE ",
  "basal_unit":"(IE/H)",
  "basal_unit2":"IE/H",

  // 告警
  "Alerts_Patch_Battery_Low":"Patch-Batterie schwach",
  "Alerts_Patch_Battery_Depleted":"Patch-Batterie leer", // update
  "Alerts_Lost_Pump":"Lost Pump",
  "Alerts_Low_Reservoir":"Behälterstand niedrig", // update
  "Alerts_Empty_Reservoir":"Leerer Behälter",
  "Alerts_Patch_Expiration_Advisory":"Patch-Verfall-Erinnerung",
  "Alerts_Patch_Exp_In_1_Hour":"Patch Exp In 1 Hour",
  "Alerts_Patch_Expired":"Patch verfallen", // update
  "Alerts_Patch_Error":"Patch-Error",
  "Alerts_Pump_Base_Error":"Pumpenbasis-Error",
  "Alerts_Basal_Rate_Key_Error":"Basal Rate Key Error",
  "Alerts_Occlusion_Detected":"Verschluss entdeckt", // update
  "Alerts_End_Of_Suspend":"End Of Suspend",
  "Alerts_Exceeds_Max_TDD":"Überschreitet max. GTD", // update
  //"Alerts_Exceeds_Max_TDD":"Exceeds Max TDD",
  "Alerts_Exceeds_Max_1Hr_Delivery":"Überschreitet max. stündl. Abgabe",
  //"Alerts_Exceeds_Max_1Hr_Delivery":"Exceeds Max 1Hr Delivery",
  "Alerts_Predictive_Low_Suspend":"Vorwarnung Niedrige Unterbrechung", // update
  "Alerts_Low_Suspend":"Niedrige Unterbrechung",
  "Alerts_Auto_Off":"Automatische Unterbrechung", // update

  "Alerts_Pump_Restart":"Pump Restart",  // 22
  "Alerts_Auto_Off_Warning":"Auto Off Warning",  // 23
  "Alerts_Pump_Out_Of_Range":"Pump Out Of Range",  //24
  //"Alerts_Pump_Out_Of_Range":"Pump Out Of Range",  // 25
  //"Alerts_Pump_Out_Of_Range":"Pump Out Of Range",  //33

  "Alerts_Lost_Sensor":"Sensorsignal verloren", // update
  "Alerts_Transmitter_Battery_Low":"Sender-Batterie schwach",
  "Alerts_Charge_Transmitter":"Sendeanlage aufladen",
  "Alerts_Sensor_Error":"Keine Lesungen",
  "Alerts_Transmitter_Error":"Sender-Error",
  "Alerts_Sensor_Calibration_Error":"Sensor Calibration Error",
  //"Alerts_Sensor_Calibration_Error":"Sensor Calibration Error",
  "Alerts_Sensor_Failure":"Sensor-Fehler ",
  "Alerts_Sensor_Calibration_Reminder":"Sensor Calibration Reminder",
  "Alerts_Meter_BG_Now":"BZ jetzt messen",
  "Alerts_Sensor_Exp_in_6_Hours":"S-Verfall in 6 Std.",
  "Alerts_Sensor_Exp_in_2_Hours":"S-Verfall in 2 Std.", // update
  "Alerts_Sensor_Exp_in_30_Min":"S-Verfall in 30 Min.",
  "Alerts_Sensor_Expired":"Sensor verfallen", // update
  "Alerts_Rapid_Rise":"Schnelle Zunahme",
  "Alerts_Rapid_Fall":"Schnelle Abnahme",
  "Alerts_High_Predicted":"Hoch Vorwarnung",
  "Alerts_Low_Predicted":"Niedrig Vorwarnung",
  "Alerts_High_Glucose":"Hohe Glukosewerte", // update
  "Alerts_Low_Glucose":"Niedrige Glukosewerte", // update
  "Alerts_Below_3.1_mmol/L":" Unter 3.1 mmol/L  ",
  "Alerts_Transmitter_Battery_Low_2":"Sender-Batterie schwach",

  "Alerts_PDM_Battery_Low":"PDM-Batterie schwach",
  "Alerts_Replace_Battery":"Laden Sie den PDM auf",

  // Alert页面
  "Alert":"Alert",
  "Alerts":"Warnmeldungen",
  "Alert Filter":"Alert Filter",
  "PDM":"PDM",
  "Pump":"Pumpe",
  //"CGM":"CGM",
  "alert_Time":"Time",
  "alert_Type":"Type",

  "Out Of Range": "Out Of Range",
  "t1221_Time_in_Auto_Mode":"Zeit im Auto-Modus",
  "t1221_Average_SG_SD":"Durchschnittlicher SG ± SD",
  "t1221_Time_in_Target_Range":"Zeit im Zielbereich",
  "t1221_Time_above_Range":"Zeit über Bereich",
  "t1221_Time_below_Range":"Zeit unter Bereich",
  "t1221_Auto_Basal_per_day":"Auto Basal (pro Tag)",
  "t1221_Auto_Bolus_per_day":"Auto Bolus (pro Tag)",
  "t1221_Auto_Mode_Exits":"Auto-Modus beendet",
  "t1221_No_Sensor_readings":"Keine Sensormessungen",
  "t1221_Max_Delivery":"Max. Lieferung",
  "t1221_Min_Delivery":"Min. Lieferung",
  "t1222_autoModeBasal":"Auto-Modus Basal",
  "t1222_autoModeCorrBolus":"Auto-Modus Korrekter Bolus ",
  "t1222_autoSnack":"Auto Snack",
  "t1222_autoBreakfast":"Auto Frühstück",
  "t1222_autoLunch":"Auto Mittagessen",
  "t1222_autoDinner":"Auto Abendessen",
  "t1222_autoExercise":"Auto Übung",
  "t1222_Snack":"Snack",
  "t1222_Auto_Mode":"Auto-Modus",
  "t1222_Time_in_Auto_Mode":"Zeit im Auto-Modus(%)",
  "t1222_Avg_SD":"Durchschnitt (mmol/L)±SD",
  "t1222_Target_Range":"Zielbereich(%)",
  "t1222_Above_Range":"Über Bereich(%)",
  "t1222_Below_Range":"Unter Bereich(%)",
  "t1222_Auto_Mode_Exits":"# von Auto-Modus  beendet",
  "t1221_Auto_Mode":"Auto-Modus",
  "t1222_auto_basal":"Auto Basal",
  "t1222_auto_bolus":"Auto Bolus",
  "t0805_User_Management":"Benutzerverwaltung",
  "t0805_Patient_Management":"Patienten Management",
  "t0805_Operation_History":"Betriebsverlauf",
  "t0805_User_List":"Benutzerliste",
  "t0805_User":"Nutzer",
  "t0805_Time":"Zeit",
  "t0805_Operation_Type":"Operationstyp",
  "t0805_Back":"Zurück",
  "t0805_Add":"Hinzufügen",
  "t0805_Delete":"Löschen",
  "t0809_Add_User":"Benutzer hinzufügen",
  "t1028_Pattern_C":"Vorlage C",
  "t1028_Pattern_D":"Vorlage D",
  "t1029_Auto_meal_bolus":"Auto meal bolus",
  "t1029_Auto_mode_correction_bolus":"Auto mode correction bolus",
  "t1029_Sick":"Krank",
  "t1029_Auto_Mode_Feature":"Automatik-Modus",
  "t1029_Target_SG":"Target SG",
  "t1029_Auto_Meal_Handling":"Auto Malzeit Bolus",
  "t1029_Total_Daily_Dose":"Ges. täglicher Dosis ",
  "t1029_Pump_Light":"Pumpenlicht",
  "t1029_Alerts_for_Hypo":"Warnmeldungen für Unter",
  "t1102_Out_of_Range":"Außer Bereichs",
  "t1102_Command_Reminder":"Befehlserinnerung",
  "t1102_Alarms_Alerts_on_APP":"Alarme und Warnungen an der Pumpe",
  "t1102_Alarms_on_App":"Alarme auf App",
  "t1102_Alerts_on_App":"Alerts On App",
  "t1102_Factory_Calibration":"Werks Kalibrierung",
  "t1102_Alerts_for_Low":"Warnungen für niedrigen BZ",
  "t1102_Alerts_for_High":"Warnungen für hohen BZ",
  "t1102_Alerts_for_Others":"andere Warnungen ",
  "t1102_Adjustment":"Anpassung",
  "t1102_Suggested":"Empfohlen",
  "t1103_Glucose":"Glukose",
  "t1103_CGM":"CGM",
  "t1103_Insulin":"Insulin",
  "t1103_Carbs":"Kohlenhydrate",
  "t1103_Exercise":"Bewegung",
  "t1103_Min_Max":"Min/Max",
  "t1103_Target_Range":"Zielbereich",
  "t1103_Overall_Tine_In_Range":"Übersicht: Zeit im Zielbereich",
  "t1103_Basal":"Basal",
  "t1103_Bolus":"Bolus",
  "t1103_Basal_Bolus":"Basal & Bolus",
  "t1103_Auto_Mode_Time_In_Range":"Auto-Modus: Zeit im Zielbereich",
  "t1103_Time_below_range":"Zeit unterhalb des Zielbereichs",
  "t1103_Time_above_range":"Zeit oberhalb des Zielbereichs",
  "t1103_Time_in_target_range":"Zeit im Zielbereich",
  "t1103_Incorrect_Password":"Falsches Passwort, $1 Versuch links, bitte geben Sie das richtige Passwort ein.",
  "t1103_Incorrect_locked":"Fehlgeschlagene Versuche überschreiten das Limit, das Konto wurde gesperrt. Bitte versuchen Sie es in $1 Minuten erneut.",
  "t1104_The_data_is_from":"Die Daten stammen von der EasySense App oder der EasyPatch App.",
  "t1104_Privacy_Policy":"Datenschutzerklärung und Nutzungsbedingung",
  "t1104_updated_privacy_policy":"Wir haben unsere Datenschutzbestimmungen und Nutzungsbedingungen aktualisiert. Bitte lesen Sie   die neuen Bedingungen sorgfältig durch und stimmen Sie ihnen zu, bevor Sie das Easy-Patch System verwenden.",
  "t1104_Disagree":"Nicht einverstanden",
  "t1104_Agree":"Zustimmen",
  "t1105_Upload_History":"Upload-Verlauf",
  "t1105_Delete_Data":"Daten löschen",
  "t1105_Target_Range":"Zielbereich",
  "t1105_request_to_view_your_data":"$1 Anfrage, um Ihre Daten anzuzeigen.",
  "t1105_Recent_Updates":"Neueste Updates",
  "t1108_No_data":"Keine Daten",
  "t1108_Pump_Bash_SN":"Pumpenbasis-SN",
  "t1108_Transmitter_SN":"Sendeanlage-SN",
  "t1112_Normal_Glucose":"Normale Glukose",
  "t1112_Manual_Bolus_or_Modified_Bolus":"Manueller Bolus oder modifizierter Bolus",
  "t1112_Auto_Mode_Started":"Automodus hat begonnen",
  "t1112_Auto_Mode_Exit":"Automodus Abbruch",
  "t1112_Normal_Bolus":"Normaler Bolus",
  "t1112_Extended_Bolus":"Verzög. Bolus",
  "t1112_Combo_Bolus":"Combo-Bolus",
  "t1112_Carbs":"Kohlenhydrate",
  "t1112_Glucose":"Glukose",
  "t1112_BG":"BZ",
  "t1112_Audio":"Audio",
  "t1112_Tone":"Ton",
  "t1112_Audio_Options":"Ton-Optionen",
  "t1112_Weight_Unit":"Gewichtseinheit",
  "t1112_Height_Unit":"Höheneinheit",
  "t1112_Not_available":"Nicht Verfügbar",
  "t1112_Number":"Nummer",
  "t1112_days":"# tage",
  "t1112_min":"min",
  "t1113_days":"tage",
  "t1215_Security":"Sicherheit",
  "t1215_MFA":"Multi-Faktor-Authentifizierung (MFA)",
  "t1215_Enter_verification_code":"Bestätigungscode eingeben",
  "t1215_Multi_factor_ON":"Die Multi-Faktor-Authentifizierung ist aktiviert. Der Bestätigungscode wurde an $1 gesendet Bitte senden Sie den Bestätigungscode.",
  "t1215_Verification_code_incorrect":"Bestätigungscode ",
  "t1215_Show_Glucose_Value":"Glukosewert anzeigen",
  "t1221_enter_verification_code":"Bitte geben Sie den 6-stelligen Bestätigungscode ein, der an $1 gesendet wurde.",
  "t1221_Verification_Success":"Erfolgreich bestätigt",
  "t1222_We_will_only_process":"Wir werden Ihre Gesundheitsdaten nur mit Ihrer Zustimmung über die Medtrum App/Website verarbeiten. ",
  "t1222_If_you_are_under_years":"Wenn Sie unter 16 Jahre alt sind, benötigen Sie die Zustimmung Ihres Elternteils oder Erziehungsberechtigten, um sich in dieser App zu registrieren .",
  "t1221_register_cn":"Sie haben das Recht, keine Gerätedaten in die App hochzuladen. In diesem Fall sind die Daten anderen nicht zugänglich. Wenn Sie sich nicht für die Medtrum App/Webseiten registrieren, werden nur Ihre Gesundheitsdaten auf dem Gerät selbst gespeichert. ",
  "t1221_register_eu":"Wenn Sie sich für die Registrierung Ihres Medtrum-Kontos entscheiden und über das Konto auf unsere App zugreifen, werden die in der App aufgezeichneten Gesundheitsdaten auf unseren Server in Europa hochgeladen und 2 Jahre lang aufbewahrt. Sie haben das Recht, keine Gerätedaten in die App hochzuladen. In diesem Fall sind die Daten anderen nicht zugänglich. Wenn Sie sich nicht für die Medtrum App/Webseiten registrieren, werden nur Ihre Gesundheitsdaten auf dem Gerät selbst gespeichert.",
  "t1221_register_follow":"Wir werden Ihre Gesundheitsdaten nur mit Ihrer Zustimmung über die Medtrum App/Webseiten verarbeiten.",
  "t1222_Terms_of_Use":"den Nutzungsbedingungen von Medtrum zu",
  "t1222_Privacy_Policy":"der Datenschutz-Erklärung von Medtrum zu",
  "t1222_Create_Account":"Benutzerkonto anlegen",
  "t1222_Back":"Zurück",
  "t1222_Verify_your_account":"Bestätige dein Konto",
  "t1222_please_check_your_account":"Wir senden einen Verifizierungscode an $1, bitte überprüfen Sie Ihr Konto.",
  "t1222_I_Agree_to":"Ich stimme $1",
  "t1223_Invalid_Verification_Code":"Ungültiger Bestätigungscode. Bitte versuche es erneut.",
}

//export default  {
//  deMessages
//}



// WEBPACK FOOTER //
// ./src/lang/de.js